"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zipPreparedJobTopic = exports.prepareImageForPrintTopic = exports.prepareJobDownloadTopic = exports.prepareForPrintTopic = void 0;
exports.prepareForPrintTopic = 'prepareForPrint';
exports.prepareJobDownloadTopic = 'prepareJobDownload';
exports.prepareImageForPrintTopic = 'prepareImageForPrint';
exports.zipPreparedJobTopic = 'zipPreparedJob';
